/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'goal-content.goal-about-content.description-edit-button': 'Редактировать',
  'project-actions.project-content-about.edit-description-error-description':
    'Произошла ошибка. Повторите попытку через несколько минут.',
  'project-content.project-content-about.edit-description-error-title': 'Не удалось отредактировать описание проекта',
  'project-content.project-content-about.the-measure-placeholder':
    'Расскажите подробнее о том, чего вы хотите достичь.',
  'project-content.project-content-about.the-measure-title': 'Как будет определяться успех',
  'project-content.project-content-about.the-what-placeholder': 'Опишите проект и связанные с ним задачи.',
  'project-content.project-content-about.the-what-title': 'Чем мы занимаемся',
  'project-content.project-content-about.the-why-placeholder':
    'Разъясните, зачем выполняются эти задачи и какие цели они преследуют.',
  'project-content.project-content-about.the-why-title': 'Зачем мы этим занимаемся',
  'project-content.project-content-update-date.edited': '(отредактировано)',
  'project-content.project-content-update-date.edited-tooltip': 'Отредактировано: {date}',
  'project-content.project-content-update-date.last-edited-by': '(последний раз редактировалось пользователем {name})',
  'project-content.project-content-updates.add-update': 'Добавить обновление',
  'project-content.project-content-updates.archived': 'Архивированные',
  'project-content.project-content-updates.at-risk': 'В зоне риска',
  'project-content.project-content-updates.cancelled': 'Отменено',
  'project-content.project-content-updates.completed': 'Выполнено 🎉',
  'project-content.project-content-updates.date-changed': 'Изменилась дата',
  'project-content.project-content-updates.edit-update': 'Редактировать',
  "project-content.project-content-updates.for-date'": 'на {dueDate}',
  'project-content.project-content-updates.latest-update-title': 'Последнее обновление',
  'project-content.project-content-updates.missed-update-message': 'Нет опубликованных обновлений',
  'project-content.project-content-updates.new-due-date': 'Новая дата выполнения',
  'project-content.project-content-updates.new-state': 'Новый статус',
  'project-content.project-content-updates.no-updates-description': 'Обновлений по проекту пока нет.',
  'project-content.project-content-updates.off-track': 'С отставанием от графика',
  'project-content.project-content-updates.old-due-date': 'Прежняя дата выполнения',
  'project-content.project-content-updates.old-state': 'Прежний статус',
  'project-content.project-content-updates.on-track': 'По графику',
  'project-content.project-content-updates.paused': 'Приостановлено',
  'project-content.project-content-updates.pending': 'В ожидании',
  'project-content.project-content-updates.previous-updates-title': 'Предыдущие обновления',
  'project-content.project-content-updates.share-update': 'Поделиться',
  'project-content.project-content-updates.status-changed': 'Изменен статус',
  'project-content.project-content-updates.write-update-button': 'Написать обновление',
  'project-update-composer.modal-post-button-label': 'Опубликовать обновление',
  'project-update-composer.modal-title': 'Опубликуйте свое обновление',
};
